export default "__VITE_ASSET__642a0367__"